import React, { useState } from "react";
import Footer from '../components/Footer';
import Nav from '../components/Nav';
import Sidebar from '../components/Sidebar';
import { getApp } from "../utils/helpers";

const MainLayout = ({ children }) => {
    const currentApp = getApp();
    const [isOpen, setIsOpen] = useState(false);

    function toggleNavMobile() {
        setIsOpen(!isOpen);
    }

    return (
        <>
            <Sidebar isOpen={isOpen} toggle={toggleNavMobile} partnerParam={currentApp} />
            <Nav toggle={toggleNavMobile} fgtsPartner={currentApp} />
            {children}
            <Footer fgtsPartner={currentApp} />
        </>
    );
};
export default MainLayout;